import { QueryConfig } from "store/utils/query-config";

export const WACallLogsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-startedAt"],
  },
};
